/*global kakao*/

import React, { Component } from "react";

import './kakaomap.css';


class KakaoMapContent extends Component {  
  componentDidMount() {    
    const script = document.createElement("script");
    script.async = true;
    script.src =
      "https://dapi.kakao.com/v2/maps/sdk.js?appkey=49d851d187e102d74bd7f97399a82da1&autoload=false";
    document.head.appendChild(script);

    script.onload = () => {
      kakao.maps.load(() => {
        this.props.parent.onKakaoScriptLoadEndHandler();
      });
    };
  }

  render() {
    return (
      <div id="map" style={{height:(this.props.height) + "px"}} />
    );
  }
}

export default KakaoMapContent;